// Eén stille regel "Team": per gevulde rol de naam(en). Geen avatars, geen kleuren — rust boven
// decoratie (policies/ff-design.md, memory "rustige schermen").
import { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { T } from './stitch';
import { teamRollen, heeftTeamIds } from './teamRollen';
import { BACKEND_URL } from '../../../utils/apiConfig';
import { authFetch } from '../../../utils/authHelpers';

// Eén keer per sessie: alle personen (ook freelancers en gearchiveerden — een oud project
// kan een oud-collega als editor hebben).
let personenBelofte = null;
export function haalNaamMap() {
  if (!personenBelofte) {
    personenBelofte = authFetch(`${BACKEND_URL}/Api/personen/all`)
      .then((r) => { if (!r.ok) throw new Error(`Personen ${r.status}`); return r.json(); })
      .then((d) => new Map((d?.people || []).map((p) => [p.id, p.volledige_naam || p.naam || ''])))
      // Fout: niet cachen — het volgende project (of de volgende keer openen) probeert opnieuw.
      .catch(() => { personenBelofte = null; return new Map(); });
  }
  return personenBelofte;
}
export function _resetTeamCache() { personenBelofte = null; }   // voor tests

export default function TeamRegel({ fields, sx }) {
  const [naamMap, setNaamMap] = useState(null);
  const nodigIds = heeftTeamIds(fields);
  useEffect(() => {
    if (!nodigIds) return undefined;
    let actief = true;
    haalNaamMap().then((m) => { if (actief) setNaamMap(m); });
    return () => { actief = false; };
  }, [nodigIds]);
  const rollen = useMemo(() => teamRollen(fields, naamMap), [fields, naamMap]);
  if (!rollen.length) return null;
  return (
    <Box data-testid="team-regel" sx={{ display: 'flex', alignItems: 'baseline', columnGap: 2, rowGap: 0.25, flexWrap: 'wrap',
      fontFamily: T.fontBody, fontSize: '0.85rem', color: T.text, ...sx }}>
      <Box component="span" sx={{ color: T.outline }}>Team</Box>
      {rollen.map(({ rol, namen }) => (
        <Box key={rol} component="span">
          <Box component="span" sx={{ color: T.outline }}>{rol} </Box>
          {namen.join(', ')}
        </Box>
      ))}
    </Box>
  );
}
